import { buildCompanySelection, buildSearchRequestBody } from "@/utils/searchRequestBuilder.util";
import { CompanyEntryDto } from "@advanced-sales-technologies/backend-client/models/CompanyEntryDto";
import { useMutation } from "@tanstack/react-query";

import { SearchParams } from "@/hooks/api/search/useInfiniteSearch";
import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export type DynamicListCreate = {
  force: boolean;
  name: string;
  companies: CompanyEntryDto[];
} & SearchParams;

export const useCreateDynamicList = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: DynamicListCreate) => {
      const filter = buildSearchRequestBody(requestBody);

      const selection = requestBody.companies.map((company) => ({
        company_id: company.id,
        selection: buildCompanySelection(company),
      }));

      return apiClient.listsDynamic.create({
        force: requestBody.force,
        requestBody: {
          name: requestBody.name,
          configuration: filter,
          selections: selection,
        },
      });
    },
  });

  return {
    ...mutation,
    createDynamicList: mutation.mutate,
  };
};
